<!--  -->
<template>
  <div class="page">
    <img
      class="main"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/main.png"
      alt=""
    />
    <div class="tab">
      <img :src="idx === 1 ? tabBg1 : tabBg2" alt="" />
      <div class="box"><div @click="change(item)" v-for="(item, k) in 2" :key="k"></div></div>
    </div>
    <div class="section">
      <!-- 4大亮点 -->

      <template v-if="idx === 1">
        <div class="content">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title1.png"
              alt=""
            />
          </div>
          <div class="bright-spot">
            <div class="box">
              <div class="name">品牌机构</div>
              <p>1、20多年专注考研辅导，课程服务有保障；</p>
              <p>2、购课后签署学员协议，价格透明；</p>
              <p>3、教学方式可面授可远程；</p>
            </div>
            <div class="box">
              <div class="name">优质师资</div>
              <p>1、公共课名师团队师资，授课质量更放心；</p>
              <p>2、师资可试听，不满意可更换；</p>
            </div>
            <div class="box">
              <div class="name">匹配迅速</div>
              <p>1、公共课48小时内匹配完成；</p>
              <p>2、匹配周期业内更迅速，随报随学；</p>
            </div>
            <div class="box">
              <div class="name">服务保障</div>
              <p>1、定制专属计划，全程跟进辅导；</p>
              <p>2、结合授课内容可提供授课资料；</p>
              <p>3、专属2v1授课小群，全职学管团队跟进督学</p>
            </div>
          </div>
        </div>
        <!-- 师资 -->
        <div class="content">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title4.png"
              alt=""
            />
          </div>
          <div class="teacher">
            <div
              class="box"
              v-for="(list, index) in teacherList"
              :key="index"
              @click="toTeacherDetail(list)"
            >
              <div class="name">
                <img :src="list.topicWebHead || require('../../assets/img/loginImg/default.png')" />
                <p>{{ list.publicName }}</p>
              </div>
              <div class="flag">
                <span>{{ showMajor(list.disciplineVOList) }}</span
                ><span>{{ showHighestEducation(list.highestEducation) }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="content">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title1.png"
              alt=""
            />
          </div>
          <div class="bright-spot">
            <div class="box">
              <div class="name">品牌机构</div>
              <p>1、20多年专注考研辅导，课程服务有保障；</p>
              <p>2、购课后签署学员协议，价格透明；；</p>
              <p>3、教学方式可面授可远程；</p>
            </div>
            <div class="box">
              <div class="name">优质师资</div>
              <p>1、专业课高分研究生考核培训，可提供证明；</p>
              <p>2、师资可试听，不满意可更换；</p>
            </div>
            <div class="box">
              <div class="name">匹配迅速</div>
              <p>1、专业课庞大师资信息库，平均3个工作日匹配完成，</p>
              <p>2、匹配周期业内更迅速，随报随学；</p>
            </div>
            <div class="box">
              <div class="name">服务保障</div>
              <p>1、定制专属计划，全程跟进辅导；</p>
              <p>2、提供高分笔记资料、专业课真题、模拟题等；</p>
              <p>3、专属2v1授课小群，全职学管团队跟进督学</p>
            </div>
          </div>
        </div>
        <!-- 学长 -->
        <div class="content">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title3.png"
              alt=""
            />
          </div>
          <div class="upperclassman">
            <div
              class="box"
              v-for="(item, index) in seniorList"
              :key="index"
              @click="openSenior(item.id)"
            >
              <img class="headerIcon" :src="item.avatar || defaultHead" alt="avatar" />
              <div class="info">
                <h2>{{ item.nickName }}｜{{ item.enrolYear }}</h2>
                <p>{{ item.pgCollege }}</p>
                <p>{{ item.pgSubject }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--  -->
      <div class="serve-study">
        <div class="content serve">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title5.png"
              alt=""
            />
          </div>
          <div class="serve-box">
            <div
              class="box"
              v-for="(item, index) in serveList"
              :key="index"
              @click="openServe(index)"
            >
              <img :src="item.img" alt="" />
              <p>{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="content study">
          <div class="title">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title6.png"
              alt=""
            />
            <div class="all" @click="openAllLecture">
              <span>全部</span
              ><img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/arrow.png"
                alt=""
              />
            </div>
          </div>
          <div class="material">
            <div
              class="box"
              v-for="(list, index) in lectureList"
              :key="index"
              @click="openPdf(list)"
            >
              <img
                src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/pdf1.png"
                alt=""
              />
              <h3>{{ list.name }}</h3>
            </div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="content">
        <div class="title">
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/title2.png"
            alt=""
          />
        </div>
        <div class="feedback">
          <img
            v-for="(item,index) in feedBackList" :key="index"
            :src="item"
            alt=""
          />

        </div>
      </div>
    </div>
    <div class="foot" @click="openChat">
      <div>免费课程试听</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqlectureList, reqSeniorIds } from '@/api/index';
import { reqTypeList } from '@/api/home';
import { reqTeacherList } from '@/api/studyBook/index';
import serverInfo from './serverInfo';

export default {
  components: {},
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      defaultHead: require('@/assets/img/majorSenior/headIcon.png'), // 默认头像
      tabBg1: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/tab1.png',
      tabBg2: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/tab2.png',
      serveList: serverInfo,
      idx: 1,
      dictoryData: [],
      teacherList: [],
      lectureList: [],
      seniorList: [],
      feedBackList: [
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback1.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback2.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback3.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback4.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback5.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback6.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback7.png',
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/feedback8.png',
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    // 获取分类列表
    async getTypeList() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const { data } = await reqTypeList('ONETOONE_COURSE');
      const teacherIds = data.find((ele) => ele.code === 'teacher')?.remark;
      const seniorIds = data.find((ele) => ele.code === 'senior')?.remark;
      this.dictoryData = data;
      this.showLecture(this.idx);
      this.getTeacher(teacherIds);
      this.getSeniorList(seniorIds);
    },
    // 查教师列表
    async getTeacher(teacherIds) {
      const { data } = await reqTeacherList(teacherIds, 1);
      this.teacherList = data || [];
      this.$toast.clear();
    },
    // 查学长列表
    async getSeniorList(ids) {
      const { data } = await reqSeniorIds(ids.split(','));
      this.seniorList = data || [];
      this.$toast.clear();
    },
    change(i) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      this.idx = i;
      this.showLecture(i);
      this.setCache();
    },
    showLecture(idx) {
      let ids = null;
      if (idx === 1) {
        ids = this.dictoryData.find((ele) => ele.code === 'lecture')?.remark;
      } else {
        ids = this.dictoryData.find((ele) => ele.code === 'lecture1')?.remark;
      }
      this.getLecture(ids);
      console.log(ids, 78);
    },
    async getLecture(ids) {
      const { data } = await reqlectureList(ids);
      console.log(data, 999);
      this.lectureList = data?.slice(0, 5) || [];
      this.$toast.clear();
    },
    // 跳教师详情
    toTeacherDetail(data) {
      const url = `${window.location.origin}/ark/oneToOneTeacherDetail?teacherId=${data.id}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/oneToOneTeacherDetail',
        query: {
          teacherId: data.id,
        },
      });
    },
    showMajor(list) {
      const name = list?.[0]?.discipline;
      return name;
    },
    showHighestEducation(i) {
      const obj = {
        1: '本科',
        2: '硕士',
        3: '博士',
        4: '博士后',
      };
      return obj[i];
    },
    openAllLecture() {
      let ids = null;
      if (this.idx === 1) {
        ids = this.dictoryData.find((ele) => ele.code === 'lecture')?.remark;
      } else {
        ids = this.dictoryData.find((ele) => ele.code === 'lecture1')?.remark;
      }
      this.$router.push({
        path: '/oneToOneLecture',
        query: {
          ids,
        },
      });
    },
    openChat() {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      const appUrl = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66e39b2a165a0b00012736b4' //app内弹窗链接
      const otherUrl = 'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=676686149bfdd90001515ccb' //h5和小程序
      const url = this.isApp ? appUrl : otherUrl
      if (this.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    openSenior(seniorId) {
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$router.push({
        path: '/oneToOnePersonDetail',
        query: {
          seniorId,
          source: 'oneToOne',
        },
      });
    },
    openServe(index) {
      this.$router.push({
        path: '/oneToOneServeDetail',
        query: {
          index,
          tabIdx:this.idx
        },
      });
    },
    openPdf(data) {
      const { lectureUrl, name } = data;
      this.$router.push({
        path: '/oneToOnePdfView',
        query: {
          lectureUrl,
          name,
        },
      });
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('login', {}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          console.log(wx);
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/oneToOneHome' },
        });
      }
    },
    setCache() {
      window.sessionStorage.setItem('oneToOneIdx', this.idx);
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
  },
  created() {},
  mounted() {
    document.title = '一对一课程';
    const idx = window.sessionStorage.getItem('oneToOneIdx');
    if (idx) {
      this.idx = Number(idx);
      window.sessionStorage.removeItem('oneToOneIdx');
    }
    this.getTypeList();
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  padding-bottom: 200px;
  background: #3fa0fe;
  .main {
    width: 100%;
    height: 100%;
  }
  .tab {
    position: relative;
    top: -5px;
    margin-bottom: 26px;
    padding: 0 36px;
    img {
      width: 100%;
      height: 65px;
    }
    .box {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 65px;
      > div {
        width: 50%;
        height: 65px;
      }
    }
  }
  .section {
    padding: 0 36px;
    .content {
      margin-bottom: 22px;
      background: #fff;
      border-radius: 18px;
      .title {
        position: relative;
        padding-bottom: 29px;
        > img {
          width: 100%;
        }
        .all {
          position: absolute;
          top: 0;
          right: 0;
          padding-right: 29px;
          span {
            padding-right: 7px;
            color: #6a7ea7;
            font-weight: 400;
            font-size: 22px;
          }
          img {
            width: 9px;
            height: 16px;
          }
        }
      }
    }
  }
  .bright-spot {
    display: flex;
    flex-wrap: nowrap;
    padding: 0 0 29px 29px;
    overflow-x: auto;
    .box {
      flex-shrink: 0;
      width: 234px;
      min-height: 337px;
      margin-right: 18px;
      background: linear-gradient(180deg, #f2feff 0%, #c5d8ff 100%);
      border-radius: 14px;
      .name {
        width: 100%;
        height: 80px;
        margin-bottom: 22px;
        color: #fff;
        font-weight: 500;
        font-size: 25px;
        line-height: 80px;
        text-align: center;
        background: linear-gradient(180deg, #8ee7ff 0%, #2a5ee4 100%);
        border: 2px solid #fff;
        border-radius: 14px;
      }
      p {
        padding: 0 22px;
        color: #223c71;
        font-weight: 400;
        font-size: 22px;
        line-height: 32px;
      }
      p:last-child{
        padding-bottom: 22px;
      }
    }
  }
  .teacher {
    display: flex;
    flex-wrap: nowrap;
    padding: 0 0 29px 29px;
    overflow-x: auto;
    .box {
      flex-shrink: 0;
      width: 199px;
      margin-right: 11px;
      .name {
        position: relative;
        width: 100%;
        height: 163px;
        overflow: hidden;
        text-align: center;
        background: linear-gradient(180deg, #9bdeff 0%, #aac1ff 100%);
        border-radius: 14px;
        img {
          width: 120px;
          margin-top: 18px;
        }
        p {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 47px;
          color: #fff;
          font-weight: 500;
          font-size: 22px;
          line-height: 47px;
          text-align: center;
          background: rgba($color: #1f202e, $alpha: 0.5);
          border-radius: 0 0 14px 14px;
        }
      }
      .flag {
        display: flex;
        align-content: center;
        align-items: center;
        margin-top: 7px;
        span {
          display: inline-block;
          width: 96px;
          height: 36px;
          overflow: hidden;
          color: #ff7420;
          font-weight: 400;
          font-size: 18px;
          line-height: 36px;
          white-space: nowrap;
          text-align: center;
          text-overflow: ellipsis;
          background: #fff3ec;
          border: 1px solid #ffe5d5;
          border-radius: 7px;
        }
      }
      span:last-child {
        margin-left: 7px;
        color: #3fa0fe;
        background: #ebf5ff;
        border: 1px solid #D7ECFF;
      }
    }
  }
  .feedback {
    padding: 29px;
    img {
      width: 100%;
      margin-bottom: 18px;
      border-radius: 14px;
    }
  }
  .serve-study {
    display: flex;
    justify-content: space-between;
    .serve {
      margin-right: 22px;
      .serve-box {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 11px;
        padding-left: 47px;
        .box:nth-child(2n) {
          margin-right: 0;
        }
        .box {
          margin-right: 60px;
          margin-bottom: 18px;
          text-align: center;
          img {
            width: 72px;
            height: 72px;
            margin-bottom: 7px;
          }
          p {
            width: 100%;
            color: #223c71;
            font-weight: 400;
            font-size: 22px;
            text-align: center;
          }
        }
      }
    }
  }
  .material {
    padding: 0 29px;
    padding-bottom: 20px;

    .box {
      display: flex;
      align-items: center;
      width: 270px;
      height: 67px;
      margin-bottom: 9px;
      padding: 18px 16px;
      background: #f2f5fc;
      border-radius: 14px;
      h3 {
        padding-left: 7px;
        overflow: hidden;
        color: #223c71;
        font-weight: 400;
        font-size: 22px;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 14px;
      }
      img {
        width: 25px;
        height: 29px;
      }
    }
  }
  .upperclassman {
    display: flex;
    flex-wrap: nowrap;
    padding: 0 0 29px 29px;
    overflow-x: auto;
    .box {
      position: relative;
      width: 290px;
      height: 217px;
      margin-right: 11px;
      margin-bottom: 15px;
      text-align: center;
      border-radius: 14px;
      .headerIcon {
        position: relative;
        z-index: 2;
        width: 72px;
        height: 72px;
        border-radius: 50%;
      }
      .info {
        position: relative;
        top: -35px;
        // right: 0;
        // left: 0;
        z-index: 1;
        width: 290px;
        height: 192px;
        margin: 0 auto;
        padding-top: 58px;
        background: #f2f5fc;
        border-radius: 14px;
        h2 {
          padding-bottom: 14px;
          color: #223c71;
          font-weight: 500;
          font-size: 25px;
          line-height: 36px;
          text-align: center;
        }
        p {
          padding-bottom: 4px;
          overflow: hidden;
          color: #6a7ea7;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .foot {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 10;
    width: 750px;
    height: 167px;
    padding: 22px 36px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
    div {
      margin: 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: linear-gradient(180deg, #73dcff 0%, #3187ff 100%);
      border-radius: 49px;
    }
  }
}
</style>
